import React from "react";
import PropTypes from "prop-types";
import { ajaxErrorHandler, toTitleCase } from "../../../../libs/utils";
import fileDownload from "js-file-download";
import moment from "moment/moment";
import { downloadInstance } from "../../../../services/api";

class ReportDownloadButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false
    };

    this._download = this._download.bind(this);
  }

  static propTypes = {
    report: PropTypes.object
  };

  _download() {
    const { report } = this.props;

    this.setState({ loading: true });

    downloadInstance({
      method: "get",
      url: report.downloadUrl,
      responseType: "blob"
    })
      .then(response => {
        fileDownload(
          response.data,
          report.name +
            moment().format("DD-MM-YYY-HH-mm-ss") +
            "." +
            (report.extension ? report.extension : "xlsx")
        );
      })
      .catch(ajaxErrorHandler)
      .then(() => {
        this.setState({ loading: false });
      });
  }

  render() {
    const { report } = this.props;

    return (
      <button
        className={
          "btn m-btn m-btn--icon btn-outline-warning m--margin-right-20 m--margin-bottom-20 m-btn--custom" +
          (this.state.loading
            ? " m-loader m-loader--light m-loader--left"
            : "") +
          (this.props.inline ? "" : " btn--download")
        }
        type="button"
        onClick={() => this._download()}
      >
        <span>
          <i className="la la-download" />
          <span>
            {report.label
              ? report.label
              : toTitleCase(report.name.replace(/_/g, " "))}
          </span>
        </span>
        {report.lastGeneratedAt && (
          <span className="ml-2 lastgen">{report.lastGeneratedAt}</span>
        )}
      </button>
    );
  }
}

export default ReportDownloadButton;
